import { ButtonHoverColor, ButtonSize, Color, EnumDictionary } from "utils/types/util.types";

export const colorEnumToHex: EnumDictionary<Color, string> = {
	[ Color.BLUE ]: "#38BDF8",
	[ Color.PURPLE ]: "#9333EA",
	[ Color.EMERALD ]: "#36D7B7",
	[ Color.DARK_BLUE ]: "#111827",
	[ Color.NEUTRAL ]: "#404040",
};

export const buttonHoverColorToHex: EnumDictionary<ButtonHoverColor, string> = {
	[ ButtonHoverColor.BLUE ]: "#0ea5e9",
	[ ButtonHoverColor.PURPLE ]: "#7e22ce",
	[ ButtonHoverColor.EMERALD ]: "#34d399",
	[ ButtonHoverColor.DARK_BLUE ]: "#1e293b",
	[ ButtonHoverColor.NEUTRAL ]: "#262626",
};

export const colorToButtonHoverColorDictionary: EnumDictionary<Color, ButtonHoverColor> = {
	[ Color.BLUE ]: ButtonHoverColor.BLUE,
	[ Color.PURPLE ]: ButtonHoverColor.PURPLE,
	[ Color.EMERALD ]: ButtonHoverColor.EMERALD,
	[ Color.DARK_BLUE ]: ButtonHoverColor.DARK_BLUE,
	[ Color.NEUTRAL ]: ButtonHoverColor.NEUTRAL,
}

export const buttonSizeToStylesDictionary: EnumDictionary<ButtonSize, { paddingX: string, paddingY: string, fontSize: string }> = {
	[ ButtonSize.LARGE ]: {
		paddingX: "px-10",
		paddingY: "py-4",
		fontSize: "text-base",
	},
	[ ButtonSize.MEDIUM ]: {
		paddingX: "px-7",
		paddingY: "py-3",
		fontSize: "text-base",
	},
	[ ButtonSize.SMALL ]: {
		paddingX: "px-5",
		paddingY: "py-2",
		fontSize: "text-sm",
	},
};